import { Button, Modal } from '@cfs-fixings/shared'

type PropTypes = {
  isOpen: boolean,
  onClose: () => void,
  onConfirm: () => void,
  title: React.ReactNode,
  message: string
}

const ConfirmUnsavedChangesModal = ({ isOpen, onClose, onConfirm, title, message }: PropTypes) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      size="md"
      content={
        <div className="flex flex-col gap-6 ">
          <div className="text-start text-sm mr-7 text-gray-650">{message}</div>
          <div className="flex gap-4 justify-between w-full">
            <Button
              variant="outline"
              onClick={onClose}
            >
                Cancel
            </Button>
            <Button onClick={onConfirm}>
              Confirm
            </Button>
          </div>
        </div>
      }
    />
  )
}

export default ConfirmUnsavedChangesModal
